import type { RoomUser } from 'quickvo-sdk-js';
import type { MediaSDKMediaType } from '../../media/types/main';
import type { MsgPayloadType } from './message';
import type { User } from './user';

export enum MediaSessionType {
  SINGLE = 1,
  MULTIPLE = 2,
  GROUP = 3,
}

export type MediaType = MsgPayloadType.MEDIA_AUDIO_CALL | MsgPayloadType.MEDIA_VIDEO_CALL;

export enum MediaAction {
  CALL_HANG_UP = 112, // Call hung up
  CALL_TIMEOUT, // Call timeout (unanswered)
  CALL_CANCELLED, // Call cancelled by initiator
  CALL_REJECTED, // Call rejected
  CALL_BUSY, // Line busy
  CALL_NETWORK_ERROR, // Call dropped due to network error
  CALL_PUT_THROUGH, // Call connected
  CALL_SYNC_STATUS, // Sync call status
}

export enum MediaStatus {
  CREATED = 1, // Created
  CALL, // Calling
  CALLEE, // Callee call
  JOIN, // Joined
}

export enum CallStatus {
  RINGING = 1, // ringing
  CONNECTING, // connecting
  CONNECT, // connect
  NETWORK_RECONNECTING, // network reconnecting
  NETWORK_ERROR, // network error
  OTHER_DEVICE_ANSWER, // answered on other device
}

export enum SubscribeStatus {
  DEFAULT = 0,
  SUBSCRIBEING,
  SUBSCRIBE_SUCCESS,
  SUBSCRIBE_FAIL,
}

export interface CallMemberItem extends User, RoomUser {
  id: string;
  fixed: boolean;
  sortIndex: number;
  screenSharing: boolean;
  subscribeStatus: SubscribeStatus;
}

export enum SubscribeType {
  SUBSCRIBE = 'subscribe',
  STOPSUBSCRIBE = 'stopSubscribe',
}

export enum MediaMemberStatus {
  WAITING = 1, // Waiting
  TALKING = 2, // Ing
}

export enum MediaMemberRole {
  HOST = 1, // Host
  NORMAL = 2, // Normal
}

export enum MediaCallOperateCode {
  SUCCESS = 1,
  NORMAL_ERROR = 2,
  ROOM_GROUP_BIND_FAILED = 3,
  ROOM_INIT_FAILED = 4,
  SINGLE_CHAT_NO_TARGET_USER = 5,
  CALL_SELF = 6,
  AV_ROOM_ERROR = 7,
  BUSINESS_TYPE_INVALID = 8,
  TARGET_CALLING_YOU = 10,
  USER_BUSY = 11,
  SELF_IN_CALL = 12,
  PRIVACY_BLOCK_CALL = 13,
}

export interface MediaMember extends User, RoomUser {
  status?: MediaMemberStatus;
  role?: MediaMemberRole;
  invite_user_id?: string;
  streams?: Record<
    MediaSDKMediaType,
    {
      stream: MediaStream | undefined;
      enabled: boolean;
    }
  >;
  videoMid?: string;
  screenMid?: string;
}

export interface MediaDeviceItem {
  user_device: string;
  user_id: string;
  device_id: string;
  name: string;
  avatar: string;
  device_type: number;
}
export interface MediaDeviceListRes {
  list: MediaDeviceItem[];
}
